import { Paper, styled } from '@mui/material';

export const Wrap = styled(Paper)(({ theme }) => ({
	padding: '8px 16px 8px 8px',
	borderRadius: '8px',

	display: 'flex',
	alignItems: 'center',
	gap: '16px',

	[theme.breakpoints.down('sm')]: {
		flexDirection: 'column',
	},
}));

export const Image = styled('img')(({ theme }) => ({
	width: '240px',
	height: '240px',
	objectFit: 'contain',
	flexShrink: 0,

	[theme.breakpoints.down('sm')]: {
		width: '113px',
		height: '113px',
	},
}));

export const InfoWrap = styled('div')(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '24px',

	[theme.breakpoints.down('sm')]: {
		gap: '8px',

		'& h6': {
			textAlign: 'center',
		},
	},
}));
